export const entidades = [
  { id: '01', nombre: 'AGUASCALIENTES', nom_corto: 'AGS' },
  { id: '02', nombre: 'BAJA CALIFORNIA', nom_corto: 'BC' },
  { id: '03', nombre: 'BAJA CALIFORNIA SUR', nom_corto: 'BCS' },
  { id: '04', nombre: 'CAMPECHE', nom_corto: 'CAMP' },
  { id: '05', nombre: 'COAHUILA DE ZARAGOZA', nom_corto: 'COAH' },
  { id: '06', nombre: 'COLIMA', nom_corto: 'COL' },
  { id: '07', nombre: 'CHIAPAS', nom_corto: 'CHIS' },
  { id: '08', nombre: 'CHIHUAHUA', nom_corto: 'CHIH' },
  { id: '09', nombre: 'CIUDAD DE MÉXICO', nom_corto: 'CDMX' },
  { id: '10', nombre: 'DURANGO', nom_corto: 'DGO' },
  { id: '11', nombre: 'GUANAJUATO', nom_corto: 'GTO' },
  { id: '12', nombre: 'GUERRERO', nom_corto: 'GRO' },
  { id: '13', nombre: 'HIDALGO', nom_corto: 'HGO' },
  { id: '14', nombre: 'JALISCO', nom_corto: 'JAL' },
  { id: '15', nombre: 'MÉXICO', nom_corto: 'MEX' },
  { id: '16', nombre: 'MICHOACÁN DE OCAMPO', nom_corto: 'MICH' },
  { id: '17', nombre: 'MORELOS', nom_corto: 'MOR' },
  { id: '18', nombre: 'NAYARIT', nom_corto: 'NAY' },
  { id: '19', nombre: 'NUEVO LEÓN', nom_corto: 'NL' },
  { id: '20', nombre: 'OAXACA', nom_corto: 'OAX' },
  { id: '21', nombre: 'PUEBLA', nom_corto: 'PUE' },
  { id: '22', nombre: 'QUERÉTARO', nom_corto: 'QRO' },
  { id: '23', nombre: 'QUINTANA ROO', nom_corto: 'QROO' },
  { id: '24', nombre: 'SAN LUIS POTOSÍ', nom_corto: 'SLP' },
  { id: '25', nombre: 'SINALOA', nom_corto: 'SIN' },
  { id: '26', nombre: 'SONORA', nom_corto: 'SON' },
  { id: '27', nombre: 'TABASCO', nom_corto: 'TAB' },
  { id: '28', nombre: 'TAMAULIPAS', nom_corto: 'TAMPS' },
  { id: '29', nombre: 'TLAXCALA', nom_corto: 'TLAX' },
  { id: '30', nombre: 'VERACRUZ DE IGNACIO DE LA LLAVE', nom_corto: 'VER' },
  { id: '31', nombre: 'YUCATÁN', nom_corto: 'YUC' },
  { id: '32', nombre: 'ZACATECAS', nom_corto: 'ZAC' },
];
